import moment from 'moment';
import React from 'react';
import { FaRegCalendarTimes } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { setSuppressDateIndicator } from '../../../../redux/slices/timeline';
import TooltipWrapper from '../../../../shared/atoms/TooltipWrapper';
import { ViewType } from '../../types';

interface HolidayFlagProps {
  holidays: { date: string; holiday_name: string }[];
  date: string;
  position: { left?: string; right?: string; top: string };
  transform?: string;
  viewType: ViewType;
  style?: React.CSSProperties;
}

export const HolidayFlag: React.FC<HolidayFlagProps> = ({
  holidays,
  position,
  transform,
  viewType,
  style
}) => {
  const dispatch = useDispatch();

  if (!holidays || holidays.length === 0) return null;

  const tooltipText = (
    <div className="flex flex-col gap-1 p-1">
      <b className='text-[10px] text-gray-300'>Holiday{holidays.length > 1 ? 's' : ''}:-</b>
      {holidays.map((h, i) => (
        <div key={i} className="text-xs">
          <span>{h.holiday_name}</span>
          <span className="ml-2 text-gray-300 dark:text-gray-600">({moment(h.date).format('DD MMM YYYY')})</span>
        </div>
      ))}
    </div>
  );

  const view_width = viewType === 'quarterly' ? '20px' : '20px';
  const view_fontsize = viewType === 'quarterly' ? '12px' : '12px';
  const view_ml = viewType === 'quarterly' ? '11px' : '11px';
  const view_tp = viewType === 'quarterly' ? '0px' : '-3px';
  const view_line_width = viewType === 'quarterly' ? '1px' : '2px';

  return (
    <div
        className="absolute !cursor-default bg-blue-300 holiday-flag-line"
        style={{
          width: view_line_width,
          left: position.left,
          right: position.right,
          height: '100%',
          zIndex:1,
          ...(style ?? {})
        }}
        onMouseEnter={() => dispatch(setSuppressDateIndicator(true))}
        onMouseLeave={() => dispatch(setSuppressDateIndicator(false))}
      >
        <div
          style={{
            top: position.top,
            transform,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: view_width ,
            height:  view_width ,
            position: 'sticky',
            zIndex: 100,
            marginLeft: view_ml
          }}
        >
            <TooltipWrapper message={tooltipText} placement="top">
          <div
            className="  rounded-b-full cursor-pointer  transition-transform flex items-center justify-center bg-blue-500"
            style={{
              width:    view_width ,
              height:  view_width,
            
              marginTop: view_tp // Adjust for the point
            }}
          >
            <div className="hover:scale-110 transition-transform" style={{  display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FaRegCalendarTimes
                className="text-white "
                style={{
                  fontSize: view_fontsize,
                }}
                />
            </div>
          </div>
                </TooltipWrapper>
        </div>
      </div>
  );
};
 